<template>
  <div class="range-input p-1">
    <div class="mb-2 teal-300">{{ fields.label }}</div>
    <div class="d-flex justify-content-between align-items-center teal-300">
      <FormulateInput v-bind="fields.min" class="px-0">
        <template #suffix v-if="fields.min.suffix">
          <div class="formulate-input-suffix">
            <span>{{ fields.min.suffix }}</span>
          </div>
        </template>
      </FormulateInput>
      <div class="range-input__divider mt-3"></div>
      <FormulateInput v-bind="fields.max" class="px-0">
        <template #suffix v-if="fields.max.suffix">
          <div class="formulate-input-suffix">
            <span>{{ fields.min.suffix }}</span>
          </div>
        </template>
      </FormulateInput>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    fields: {
      type: Object,
      required: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.range-input {
  &__divider {
    height: 12px;
    width: 20px;
    border-bottom: 1px solid $mep-color-text-200;
  }
}

:deep(.formulate-input) {
  &:first-child {
    margin-right: 20px;
  }

  &:last-child {
    margin-left: 20px;
  }
}
</style>
